<template>

    <td colspan="25">
        <div class="row mx-auto">
            <div class="col-12 pr-1 pl-1">
                <b-btn v-on:click="createRow()"
                       class="btn btn-sm  btn-akg-dark-green btn-with-icon-white float-left btn-block mb-3 mt-1">
                    <i class="fa fa-plus"
                       style="color:white"
                       aria-hidden="true"></i> Új sor hozzáadása
                </b-btn>
            </div>
        </div>
    </td>

</template>

<script>
export default {
  props: ["ketId"],
  data() {
    return {
      form: new Form({
        ketId: ""
      })
    };
  },

  methods: {
    createRow() {
      this.form.ketId = this.ketId;

      this.form
        .post("ajax/kets/newRow")
        .then(newRow => this.$emit("createdKetRow", newRow))
        .catch(e => {
          console.log(e.errors);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CreateKetRow.vue